import Actions from "./ReportActionTypes";

export const getAllReports = (params = {}) => {
  return {
    type: Actions.FETCH_REPORTS,
    payload: params,
  };
};
